export function $(s, c = document) {
  return c.querySelector(s);
}

export function $$(s, c = document) {
  return Array.prototype.slice.call(c.querySelectorAll(s));
}

export function isInteractiveElement(e) {
  let nodeName = e.nodeName.toLowerCase();
  if (nodeName === 'A' && e.hasAttribute('href') ||
    ['button', 'input', 'select', 'textarea'].includes(nodeName) ||
    nodeName === 'label' && (e.htmlFor || e.querySelector('input,select,textarea') !== null) ||
    ['img', 'object'].includes(nodeName) && e.useMap ||
    ['audio', 'video'].includes(nodeName) && e.controls ||
    ['summary', 'iframe', 'embed'].includes(nodeName)) {
    return true;
  }
  return e.hasAttribute('tabindex') && e.tabIndex > -1;
}
